import React from 'react';
import { Button } from './ui/button';
import { Phone, HeartHandshake, ShieldCheck, Users } from 'lucide-react';
import aboutPetcare from '../assets/about-petcare.png';

const ProblemSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">

          {/* Left - Content */}
          <div className="space-y-6">
            <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">We Understand</span>
            <h2 className="text-4xl font-bold text-slate-900 leading-tight">
              Are you worried about a loved one living alone?
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed">
              We understand how important it is to ensure your loved ones are safe, supported, and not feeling isolated.
            </p>
            <p className="text-lg text-slate-600 leading-relaxed">
              At AFT Senior Assisted Services, we provide reliable, friendly home support designed to help individuals remain independent while giving families peace of mind.
            </p>

            <div className="grid grid-cols-1 gap-4 pt-4">
              <div className="flex items-start space-x-4 p-4 bg-teal-50 rounded-xl border border-teal-100">
                <div className="flex-shrink-0 w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center">
                  <ShieldCheck className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h4 className="font-semibold text-slate-900">Safety & Peace of Mind</h4>
                  <p className="text-slate-600 text-sm mt-1">Regular visits to check your loved one is safe, comfortable and well at home.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4 p-4 bg-cyan-50 rounded-xl border border-cyan-100">
                <div className="flex-shrink-0 w-10 h-10 bg-cyan-600 rounded-lg flex items-center justify-center">
                  <Users className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h4 className="font-semibold text-slate-900">Reducing Loneliness</h4>
                  <p className="text-slate-600 text-sm mt-1">Friendly companionship visits that provide conversation, activities and emotional support.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4 p-4 bg-emerald-50 rounded-xl border border-emerald-100">
                <div className="flex-shrink-0 w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center">
                  <HeartHandshake className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h4 className="font-semibold text-slate-900">Staying Independent</h4>
                  <p className="text-slate-600 text-sm mt-1">Practical support with everyday tasks so your loved one can continue living comfortably at home.</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <a href="tel:07475473449">
                <Button size="lg" className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-6 text-lg w-full sm:w-auto">
                  <Phone className="mr-2 w-5 h-5" />
                  Call 07475 473 449
                </Button>
              </a>
              <Button onClick={scrollToContact} size="lg" variant="outline" className="border-2 border-teal-600 text-teal-700 hover:bg-teal-50 px-8 py-6 text-lg">
                Get in Touch
              </Button>
            </div>
          </div>

          {/* Right - Image */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[500px]">
            <img
              src={aboutPetcare}
              alt="Care worker walking dog with elderly client"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-teal-900/30 to-transparent"></div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ProblemSection;